module.exports = __webpack_public_path__ + "media/images/logos/node-cda4e650e427361f9075bde11e31631e.svg";